<template>
	<v-autocomplete
		ref="autocomplete"
		v-model="userSelect"
		:disabled="disabled"
		:item-title="composedText"
		:items="users"
		:label="label"
		:loading="loading"
		:messages="noResults"
		:multiple="multiple"
		append-icon=""
		clearable
		closable-chips
		hide-no-data
		hint="Type in keywords to begin searching"
		item-color="secondary"
		item-value="uuid"
		persistent-hint
		prepend-icon="mdi-magnify"
		return-object
		density="compact"
	>
		<template #chip="{ item, index }">
			<v-chip
				class="bg-secondary"
				closable
				@click:close="removeItem(index)"
			>
				{{ item.title }}
			</v-chip>
		</template>
	</v-autocomplete>
</template>

<script>
import _ from "lodash";
import utils from "@/utils";

import { mapActions } from "pinia";
import { useMainStore } from "@/store";

export default {
	name: "UserSearch",

	props: {
		defaultUsers: { type: Array, default: () => [] },
		disabled: Boolean,
		excludeAdmin: { type: Boolean, default: false },
		omitDeleted: { type: Boolean, default: false },
		label: {
			default: "Search for users",
			type: String,
		},
		modelValue: { type: [Array, Object], default: null },
		multiple: { type: Boolean, default: true },
	},
	emits: ["update:users-loading", "update:modelValue"],

	data() {
		return {
			loading: true,
			noResults: "",
			users: [],
			userSearch: null,
		};
	},

	computed: {
		userSelect: {
			get() {
				return this.modelValue;
			},
			set(newValue) {
				this.$emit("update:modelValue", newValue);
			},
		},
	},

	watch: {
		defaultUsers(val) {
			this.loadUsers(val);
		},
	},

	mounted() {
		this.queryUsers();
		this.loadUsers();
	},

	methods: {
		...mapActions(useMainStore, ["showNotification"]),
		clear() {
			this.loading = false;

			if (this.defaultUsers.length) {
				// revert to default projects if it exists
				this.loadUsers();
			}
		},
		queryUsers: _.debounce(function () {
			this.loading = "secondary";

			this.$http
				.get("/users", {
					params: {
						excludeAdmin: this.excludeAdmin,
						omitDeleted: this.omitDeleted,
					},
				})
				.then((response) => {
					this.users = response.data.users.data;
				})
				.finally(() => {
					this.loading = false;
				});
		}, 200),
		loadUsers() {
			if (this.defaultUsers.length) {
				this.userSelect = [...this.defaultUsers];
			}
		},
		composedText(user) {
			return utils.truncateText(
				`${user.last_name}, ${user.first_name} (${user.email})`,
				100,
			);
		},
		doneLoading() {
			this.loading = false;
			this.$emit("update:users-loading", false);
		},
		removeItem(index) {
			if (this.multiple) {
				this.userSelect = this.userSelect.filter((_, i) => i !== index);
			} else {
				this.userSelect = null;
			}
		},
	},
};
</script>

<style scoped lang="scss">
:deep(.v-field__input) {
	min-height: 60px;
	padding-top: 20px;
}
</style>
